import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "11.1667 6.1665 11.6667 11.6667",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.625 6.1665H19.1875L21.375 8.354V9.81234H12.625V6.1665Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.1667 11.2707H22.8334V15.6457H21.375V17.8332H12.625V15.6457H11.1667V11.2707ZM21.375 13.4582C21.375 13.8609 21.0486 14.1873 20.6459 14.1873C20.2431 14.1873 19.9167 13.8609 19.9167 13.4582C19.9167 13.0555 20.2431 12.729 20.6459 12.729C21.0486 12.729 21.375 13.0555 21.375 13.4582ZM19.9167 14.9165H14.0834V16.3748H19.9167V14.9165Z",
		fill: "currentColor"
	})]
});
export default SvgPrinter;
